var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60129 14.2231L12.7134 5.02581C13.0999 4.52983 13.2374 3.95641 13.1085 3.37256C12.9968 2.84177 12.6704 2.3371 12.1808 1.95424L10.9869 1.0058C9.94758 0.17917 8.65915 0.266183 7.92045 1.21463L7.12163 2.25096C7.01856 2.3806 7.04433 2.57203 7.17317 2.67645C7.17317 2.67645 9.1917 4.2949 9.23465 4.3297C9.37208 4.46022 9.47515 4.63425 9.50092 4.84308C9.54387 5.25204 9.26042 5.6349 8.83953 5.68711C8.64197 5.71321 8.453 5.6523 8.31557 5.53919L6.19397 3.85113C6.09089 3.77369 5.93628 3.79022 5.85039 3.89464L0.808351 10.4206C0.48195 10.8296 0.370287 11.3604 0.48195 11.8737L1.12616 14.6669C1.16052 14.8148 1.28936 14.9192 1.44397 14.9192L4.27851 14.8844C4.79388 14.8757 5.27489 14.6408 5.60129 14.2231ZM9.5699 13.3531H14.1919C14.6429 13.3531 15.0096 13.7247 15.0096 14.1815C15.0096 14.6392 14.6429 15.0099 14.1919 15.0099H9.5699C9.11895 15.0099 8.75218 14.6392 8.75218 14.1815C8.75218 13.7247 9.11895 13.3531 9.5699 13.3531Z",
    fill: "#1479E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.6aa689cbff9b475c65d5850b46d4bbae.svg";
export { ForwardRef as ReactComponent };